import { render } from "./ChallengeGameWrapper.vue?vue&type=template&id=cd05bf9c&scoped=true"
import script from "./ChallengeGameWrapper.vue?vue&type=script&lang=js"
export * from "./ChallengeGameWrapper.vue?vue&type=script&lang=js"

import "./ChallengeGameWrapper.vue?vue&type=style&index=0&id=cd05bf9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd05bf9c"]])

export default __exports__